import { KAPLAYCtx, SpriteCompOpt } from "kaplay";

function make_background(k: KAPLAYCtx, name: string, x: number, y: number, opt: SpriteCompOpt = {}) {
  return [k.sprite(name, opt), k.pos(x, y), k.layer("bg")];
}
function wall_topper(k: KAPLAYCtx, id: number, x: number, y: number) {
  return [k.sprite("wall_topper", { frame: id }), k.pos(x, y), k.layer("bg")];
}

function make_furniture(k: KAPLAYCtx, name: string, x: number, y: number, opt: SpriteCompOpt = {}) {
  return [k.sprite(name, opt), k.pos(x, y), k.layer("furniture")]

}

function make_house(k: KAPLAYCtx) {
  // prettier-ignore
  let floors = [
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  ];
  for (let y = 0; y < floors.length; y++) {
    for (let x = 0; x < floors[y].length; x++) {
      if (floors[y][x] == 1) {
        k.add(make_background(k, "floor", 16 * 7 + x * 16, 64 + y * 16));
      }
      if (floors[y][x] == 2) {
        k.add(make_background(k, "kitchen_floor", 16 * 7 + x * 16, 64 + y * 16));
      }
    }
  }
  k.add(make_background(k, "wall_left", 16 * 7, 64));
  k.add(make_background(k, "wall_middle", 16 * 8, 64));
  k.add(make_background(k, "wall_right", 16 * 9, 64));
  k.add(make_background(k, "wall_left", 16 * 10, 32));
  k.add(make_background(k, "wall_middle", 16 * 11, 32));
  k.add(make_background(k, "wall_middle", 16 * 12, 32));
  k.add(make_background(k, "wall_middle", 16 * 13, 32));
  k.add(make_background(k, "wall_middle", 16 * 14, 32));
  k.add(make_background(k, "wall_middle", 16 * 15, 32));
  k.add(make_background(k, "wall_middle", 16 * 16, 32));
  k.add(make_background(k, "wall_right", 16 * 17, 32));
  k.add(make_background(k, "wall_left", 16 * 18, 64));
  k.add(make_background(k, "wall_middle", 16 * 19, 64));
  k.add(make_background(k, "wall_middle", 16 * 20, 64));
  k.add(make_background(k, "wall_middle", 16 * 21, 64));
  k.add(make_background(k, "wall_right", 16 * 22, 64));
  k.add(wall_topper(k, 1, 16 * 6, 48));
  k.add(wall_topper(k, 38, 16 * 7, 48));
  k.add(wall_topper(k, 38, 16 * 8, 48));
  k.add(wall_topper(k, 27, 16 * 9, 48));
  k.add(wall_topper(k, 12, 16 * 9, 32));
  k.add(wall_topper(k, 1, 16 * 9, 16));
  k.add(wall_topper(k, 38, 16 * 10, 16));
  k.add(wall_topper(k, 38, 16 * 11, 16));
  k.add(wall_topper(k, 38, 16 * 12, 16));
  k.add(wall_topper(k, 38, 16 * 13, 16));
  k.add(wall_topper(k, 38, 16 * 14, 16));
  k.add(wall_topper(k, 38, 16 * 15, 16));
  k.add(wall_topper(k, 38, 16 * 16, 16));
  k.add(wall_topper(k, 38, 16 * 17, 16));
  k.add(wall_topper(k, 3, 16 * 18, 16));
  k.add(wall_topper(k, 12, 16 * 18, 32));
  k.add(wall_topper(k, 25, 16 * 18, 48));
  k.add(wall_topper(k, 38, 16 * 19, 48));
  k.add(wall_topper(k, 38, 16 * 20, 48));
  k.add(wall_topper(k, 38, 16 * 21, 48));
  k.add(wall_topper(k, 38, 16 * 22, 48));
  k.add(wall_topper(k, 3, 16 * 23, 48));
  k.add(wall_topper(k, 12, 16 * 23, 64));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 5));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 6));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 7));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 8));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 9));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 10));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 11));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 12));
  k.add(wall_topper(k, 12, 16 * 23, 16 * 13));
  k.add(wall_topper(k, 27, 16 * 23, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 22, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 21, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 20, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 19, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 18, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 17, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 16, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 15, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 14, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 13, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 12, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 11, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 10, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 9, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 8, 16 * 14));
  k.add(wall_topper(k, 38, 16 * 7, 16 * 14));
  k.add(wall_topper(k, 25, 16 * 6, 16 * 14));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 13));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 12));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 11));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 10));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 9));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 8));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 7));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 6));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 5));
  k.add(wall_topper(k, 12, 16 * 6, 16 * 4));

}

function furnish_house(k: KAPLAYCtx) {
  k.add(make_furniture(k, "bed", 16 * 10, 16 * 3 + 4));
  k.add(make_furniture(k, "lamp", 16 * 15 - 8, 16 * 3 + 4));
  k.add(make_furniture(k, "grandfather_clock", 16 * 17 - 1, 16 * 3 - 1));
  k.add(make_furniture(k, "teddy_bear", 16 * 13, 16 * 4 - 4));
  k.add(make_furniture(k, "calendar", 16 * 13 + 8, 16 * 2));
  k.add(make_furniture(k, "cat_stand", 16 * 7 + 4, 16 * 8 + 4));
  k.add(make_furniture(k, "closet", 16 * 15 + 4, 16 * 2));
  k.add(make_furniture(k, "sofa", 16 * 7, 16 * 11, { flipX: true }));
  k.add(make_furniture(k, "bookshelf", 16 * 7, 16 * 4));
  k.add(make_furniture(k, "fridge", 16 * 22 - 2, 16 * 5 - 7));
  k.add(make_furniture(k, "stove", 16 * 21 - 2, 16 * 5 - 7));
  k.add(make_furniture(k, "counter", 16 * 20 - 2, 16 * 6 - 7));
  k.add(make_furniture(k, "sink", 16 * 19 - 2, 16 * 5 - 7));
  k.add(make_furniture(k, "knives", 16 * 19 + 6, 16 * 5 - 11));
  k.add(make_furniture(k, "chairs", 16 * 20 + 9, 16 * 10 - 4, { frame: 0 }));
  k.add(make_furniture(k, "chairs", 16 * 21 + 8, 16 * 11 - 8, { frame: 3 }));
  k.add(make_furniture(k, "chairs", 16 * 20 - 8, 16 * 11 - 8, { frame: 2 }));
  k.add(make_furniture(k, "table", 16 * 20, 16 * 11));
  k.add(make_furniture(k, "chairs", 16 * 20 + 9, 16 * 12 - 8, { frame: 1 }));
  k.add(make_furniture(k, "side_table", 16 * 7, 16 * 13));
  k.add(make_furniture(k, "flowers", 16 * 7, 16 * 10));
  k.add(make_furniture(k, "island", 16 * 20, 16 * 8));
  k.add(make_furniture(k, "cat_tent", 16 * 7, 16 * 6));
  k.add(make_furniture(k, "litter_box", 16 * 8 + 4, 16 * 7));
  k.add(make_furniture(k, "phone", 16 * 7 + 2, 16 * 13 - 2));

}

export { make_house, furnish_house };
